module.exports = __webpack_public_path__ + "img/closeIcon.be0a01d4.svg";